import module from 'recursoshumanos/module.js'
import template from './template.html'
import { groupBy } from 'lodash'

export class RecursoshumanosReportesIncapacidadesItemComponent {
  data

  $onChanges (changes) {
    if (changes.data) {
      this.data = groupBy(this.data, 'colaborador')
    }
  }
}

module.component('recursoshumanosReportesIncapacidadesItem', {
  controller: RecursoshumanosReportesIncapacidadesItemComponent,
  template,
  bindings: {
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/reportes/incapacidades/item/component.js